"use strict";
/**
 * @module Services.Timeseries
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a TIME_SERIES_APPEND request.
 */
var TimeSeriesAppendRequest = /** @class */ (function () {
    /**
     * Create a new TimeSeriesAppendRequest instance
     *
     * @param path  the path of the timeseries topic
     * @param dataType  the data type to append
     * @param value  the value to append
     */
    function TimeSeriesAppendRequest(path, dataType, value) {
        this.path = path;
        this.dataType = dataType;
        this.value = value;
    }
    return TimeSeriesAppendRequest;
}());
exports.TimeSeriesAppendRequest = TimeSeriesAppendRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/timeseries/time-series-append-request.js
// module id = 1381
// module chunks = 1